import { latestVideoApi as api } from './latest-video.api';

export const latestVideoActions = {
  async getLatestVideos({ commit }, payload) {
    try {
      commit('GET_LATEST_VIDEOS_LOADING');
      const response = await api.getLatestVideos(payload);
      commit('GET_LATEST_VIDEOS_SUCCESS', response.data);
      return response;
    } catch (error) {
      commit('GET_LATEST_VIDEOS_ERROR', error.response);
    }
  },
  async getLatestVideo({ commit }, id) {
    try {
      commit('GET_LATEST_VIDEO_LOADING');
      const response = await api.getLatestVideo(id);
      commit('GET_LATEST_VIDEO_SUCCESS', response.data);
    } catch (error) {
      commit('GET_LATEST_VIDEO_ERROR', error.response);
    }
  },
  async addLatestVideo({ commit }, body) {
    try {
      commit('ADD_LATEST_VIDEO_LOADING');
      const response = await api.addLatestVideo(body);
      commit('ADD_LATEST_VIDEO_SUCCESS', response.data);
    } catch (error) {
      commit('ADD_LATEST_VIDEO_ERROR', error.response);
    }
  },
  async deleteLatestVideo({ commit }, id) {
    try {
      commit('DELETE_LATEST_VIDEO_LOADING');
      const response = await api.deleteLatestVideo(id);
      commit('DELETE_LATEST_VIDEO_SUCCESS', response.data);
    } catch (error) {
      commit('DELETE_LATEST_VIDEO_ERROR', error.response);
    }
  },
  async updateLatestVideo({ commit }, { id, body }) {
    try {
      commit('UPDATE_LATEST_VIDEO_LOADING');
      const response = await api.updateLatestVideo(id, body);
      commit('UPDATE_LATEST_VIDEO_SUCCESS', response.data);
    } catch (error) {
      commit('UPDATE_LATEST_VIDEO_ERROR', error.response);
    }
  },
};
